module.exports = __webpack_public_path__ + "static/media/update.c4fec622.svg";